/* eslint-disable */
// import { createTheme } from "../themes/createTheme";

// export const defaultDarkTheme = createTheme({ type: 'dark' });
// export const defaultLightTheme = createTheme({ type: 'light' });
export default {}
